export const getUserState = (state) => state.user;
export const getUserEmail = (state) => state.user.user?.email;
export const getIsAuthenticatedUser = (state) => state.user.isAuthenticated;
export const getUserIp = (state) => state.user.userIp;

// Cabinet
export const getActiveOrdersIpAddressCount = (state) =>
  state.user.cabinet.activeOrdersIpAddressCount;
